import { USER_ROLES } from '@bagonboard/wiseman';
import {
  Add as NewOrderIcon,
  FlightTakeoff as ServicesIcon,
  Group as UsersIcon,
  LocalOffer as LocalOfferIcon,
  LocalShippingRounded as OpsIcon,
  InfoOutlined as HelpIcon,
} from '@material-ui/icons';

import {
  LF_ALL_ROLES, ALL_COURIER_ROLES, ALL_TRAVEL_ROLES, ALL_HOST_ROLES,
} from '#constants';

import Order from './Order';
import OrderCreation from './OrderCreation';
import Orders from './Orders';
import Service from './Service';
import Services from './Services';
import Users from './Users';

export default [
  {
    path       : '/orders',
    name       : 'Orders',
    icon       : LocalOfferIcon,
    component  : Orders,
    deniedRoles: [
      ...LF_ALL_ROLES,
      ...ALL_COURIER_ROLES,
    ],
  },
  {
    path       : '/order/:id',
    name       : 'Order details',
    component  : Order,
    hidden     : true,
    deniedRoles: [
      ...LF_ALL_ROLES,
      ...ALL_COURIER_ROLES,
    ],
  },
  {
    path       : '/service/:id',
    name       : 'Service details',
    component  : Service,
    hidden     : true,
    deniedRoles: [
      ...LF_ALL_ROLES,
      ...ALL_COURIER_ROLES,
    ],
  },
  {
    path       : '/services',
    name       : 'Services',
    icon       : ServicesIcon,
    component  : Services,
    deniedRoles: [
      ...LF_ALL_ROLES,
      ...ALL_COURIER_ROLES,
    ],
  },
  {
    path       : '/users',
    name       : 'Users',
    icon       : UsersIcon,
    component  : Users,
    deniedRoles: [
      ...LF_ALL_ROLES,
      USER_ROLES.AGENT,
      USER_ROLES.COURIER_AGENT,
      USER_ROLES.HOST_AGENT,
      USER_ROLES.SUPPORT,
      USER_ROLES.TRAVEL_COMPANY_AGENT,
      USER_ROLES.USER,
    ],
  },
  {
    path       : '/order-create',
    name       : 'Create new order',
    icon       : NewOrderIcon,
    component  : OrderCreation,
    deniedRoles: [
      ...LF_ALL_ROLES,
      ...ALL_COURIER_ROLES,
    ],
  },
  {
    name        : 'Help Center',
    icon        : HelpIcon,
    path        : '/external-help',
    externalLink: 'https://help.bob.io',
    separator   : true,
    onNewTab    : true,
    deniedRoles : [
      ...ALL_COURIER_ROLES,
      ...ALL_TRAVEL_ROLES,
      ...ALL_HOST_ROLES,
    ],
  },
  {
    name        : 'Ops tool',
    icon        : OpsIcon,
    path        : '/external',
    externalLink: 'https://ops.bob.io',
    onNewTab    : true,
    deniedRoles : [
      ...LF_ALL_ROLES,
      ...ALL_COURIER_ROLES,
      ...ALL_TRAVEL_ROLES,
      ...ALL_HOST_ROLES,
    ],
  },
  {
    redirect: true,
    path    : '/services',
  },
];
